module.exports = __webpack_public_path__ + "media/images/icons/arrow-down-5e692bf2eb8aeac0adebbadaed5788d5.svg";